
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'

import Checklistspec from '@/components/Subjects/Checklistspec'

export default {
name: 'MultipleChoices',
props: {
multichoice: {},
cuIndex: 0
},
components: {
Checklistspec, CheckerItem, Group, Cell, Checklist
},
data () {
return {
options: [],
anwser: [],
haOptions: ''
}
},
created () {
this.setOptions(this.multichoice)
},
methods: {
getAnswer () {
return this.multichoice
},
setShowOk: function () {
for (let i = 0; i < this.options.length; i++) {
this.options[i].showOk = false
}
},
setOptions: function (choice) {
this.options = []
const {options} = choice.choices
const {userAnswer} = choice
this.options = options
this.setShowOk()
if (userAnswer) {
this.anwser = userAnswer.split(',')
}
},
toggleOption (value) {
if (value.length>0) {
const res = new Map()
value = value.filter((a) => !res.has(a) && res.set(a, 1))
let inputs = []
for (let j = 0; j < value.length; j++) {
for (let i = 0; i < this.options.length; i++) {

if (value[j] === this.options[i].id) {
this.options[i].showOk = true
if (this.options[i].inputVal) {
let temp = {}
temp.optionId = value[j]
temp.optionInput = this.options[i].inputVal
inputs.push(temp)
}
}
}
}
let valueTxt = ','+value.toString()+',';
for (let i = 0; i < this.options.length; i++) {
if((valueTxt).indexOf(','+this.options[i].id+',') ==-1){
this.options[i].showOk = false;
}
}
this.multichoice.userInput = inputs
this.multichoice.userAnswer = value.join(',')

if (value.length > 0 && this.haOptions.length === 0) {



}
}else{
this.setShowOk();
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/Subjects/MultipleChoices/index.vue